import { Layer } from './Layer'


export class Net {


	constructor(layerSize) {
		this.layers = []
		for (let i = 0; i < layerSize.length; i++) {
			this.layers[i] = new Layer(layerSize[i], i === 0 ? 0 : layerSize[i - 1])
		}
	}


	feedForward(input) {
		this.layers[0].neurons = input;
		for (let l = 1; l < this.layers.length; l++) {
			this.layers[l].activateNeurons(this.layers[l - 1].neurons);
		}
	}


	computeDeltas(target) {
		this.layers[this.layers.length - 1].computeOutputDeltas(target)
		for (let l = this.layers.length - 1; l > 1; l--) { 
			this.layers[l - 1].computeHiddenDeltas(this.layers[l])
		}
	} 


	propagateBack(learningRate) {
		for (let l = this.layers.length - 1; l > 0; l--) { 
			this.layers[l].gradientDescent(this.layers[l - 1], learningRate)
		}
	}


}


